// extracted by mini-css-extract-plugin
export var brandContainer = "footer-module--brandContainer--e5ab8";
export var brandSubtitle = "footer-module--brandSubtitle--332d0";
export var buttonStyle = "footer-module--buttonStyle--c2ec1";
export var disclaimerContainer = "footer-module--disclaimerContainer--ed3af";
export var disclaimerDescription = "footer-module--disclaimerDescription--15521";
export var footer = "footer-module--footer--954ee";
export var footerSubtitle = "footer-module--footerSubtitle--97945";
export var genericContainer = "footer-module--genericContainer--ed525";
export var gridFooterContainer = "footer-module--gridFooterContainer--8357c";
export var linkStyle = "footer-module--linkStyle--0ac4d";
export var linksContainer = "footer-module--linksContainer--ac35a";
export var modalContent = "footer-module--modalContent--df2ab";
export var modalImage = "footer-module--modalImage--e890e";
export var modalTitle = "footer-module--modalTitle--5bdf5";
export var socialMedia = "footer-module--socialMedia--6675a";
export var subscribeContainer = "footer-module--subscribeContainer--d98b4";